module.exports = __webpack_public_path__ + "img/WE.e32be936.jpg";